import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { Modal } from 'react-bootstrap';
import { ImageSecurityAlert } from '../../assets/images';
import { AuthUtils, TranslationUtils, SharedUtils } from '../../utils';
import './AccessTokenExpiredModal.scss';
import { StorageKeys } from '../../types/keys.type';
import { Button } from '../Button/Button';
import { useHistory } from 'react-router-dom';

export const AccessTokenExpiredModal: React.FC = () => {
    const { isAccessTokenExpired: showModal } = useSelector((store: StoreState) => store.user);
    const history = useHistory();

    const handleClose = () => {
        const reservtionId = SharedUtils.getSessionStorageItem(StorageKeys.RESERVATION_ID);
        if (reservtionId) {
            AuthUtils.goToIdpLoginNoPrompt(reservtionId, history.location.pathname);
            return;
        }

        AuthUtils.goToMyTripsLogin();
    };

    const blurEverything = () => {
        const app = document.getElementById('routed-app');
        if (app) {
            app.setAttribute('class', 'blur');
        }
    };

    return (
        <Modal id="access-token-modal" show={showModal} onHide={handleClose} onEnter={blurEverything}>
            <Modal.Header closeButton />

            <div className="access-token-modal-body">
                <div>
                    <ImageSecurityAlert className="access-token-modal-image" />
                </div>
                <h4 className={'heading-med-light'}>{TranslationUtils.get('access_token_expired')}</h4>
                <div className="access-token-modal-instructions">
                    <p className={'body-regular'}>{TranslationUtils.get('access_token_expired_message')} </p>
                </div>
                <div>
                    <Button className={'body-regular'} variant="info" label={TranslationUtils.get('accept')} onClick={handleClose} />
                </div>
            </div>
        </Modal>
    );
};
